import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { fonts, device } from 'components/Variable'
import { merchantThemes } from 'components/Variable'

export const ReclamationItemIndexTitle = styled.div`
	margin: ${rem(30, 0, 0, 0)};
	font-family: ${fonts.signika};
	font-style: normal;
	font-weight: 600;
	font-size: ${rem(20)};
	line-height: ${rem(25)};
	text-align: center;
	letter-spacing: ${rem(1.66667)};
	text-transform: uppercase;

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			font-weight: normal;
			text-transform: none;
			letter-spacing: ${rem(0.06)};
			line-height: ${rem(20)};
			font-size: ${rem(15)};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}

	@media (${device.mobileM}) {
		display: none;
	}
`
export const ReclamationItemIndexSubTitle = styled.div`
	font-family: ${fonts.openSans};
	font-style: normal;
	font-weight: normal;
	font-size: ${rem(14)};
	line-height: ${rem(26)};
	text-align: center;
	color: ${({ theme }) => theme.color.grayTen};
	margin-top: ${rem(20)};

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
		${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
		${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
		${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
		${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
		${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
		${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
		`}
		${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}

	@media (${device.mobileM}) {
		font-size: ${rem(12)};
	}
`
export const Title = styled.div`
	font-weight: 600;
	font-size: ${rem(16)};
	line-height: ${rem(26)};
	text-align: center;
	color: ${({ theme }) => theme.color.blackOne};
	margin-bottom: ${rem(30)};

	@media (${device.mobileM}) {
		font-size: ${rem(14)};
		margin-bottom: ${rem(20)};
		font-weight: 600;
	}
`
export const Description = styled.textarea`
	width: 100%;
	display: block;
	max-width: ${rem(468)};
	background: ${({ theme }) => theme.color.grayEleven};
	border: ${rem(1)} solid ${({ theme }) => theme.color.blackOne};
	border-radius: ${rem(2)};
	padding: ${rem(16, 18)};
	margin: 0 auto;
	resize: none;
	font-size: ${rem(16)};
	line-height: ${rem(24)};
	font-family: ${fonts.openSans};

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
	${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
		${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
		${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			background: transparent;
		`}
		${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}
`

export const ControlsWrapper = styled.div`
	${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			.contact-from-item {
				display: none;
			}
		`}
`
export const ControlsWrapperItem = styled.div`
	margin: ${rem(10, 0)};
`
